/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AutocompleteRenderInputParams, OutlinedInputProps } from '@mui/material';

export const destructRenderInputParams = (params: AutocompleteRenderInputParams): OutlinedInputProps => {
  const {
    InputProps,

    ...otherProps
  } = params;

  return { ...otherProps, ...InputProps };
};
